import React from 'react';
import { BranchesDown } from '@gravity-ui/icons';
import { Icon } from '@gravity-ui/uikit';
import abcIcon from '../../assets/icons/abc';
import atushkaIcon from '../../assets/icons/atushka';
import calendarIcon from '../../assets/icons/calendar';
import docIcon from '../../assets/icons/doc';
import goalsIcon from '../../assets/icons/goals';
import helpIcon from '../../assets/icons/helpy';
import atmIcon from '../../assets/icons/map/atm';
import balconyIcon from '../../assets/icons/map/balcony';
import batteryContainerIcon from '../../assets/icons/map/batteryContainer';
import coffeeIcon from '../../assets/icons/map/coffee';
import conferenceIcon from '../../assets/icons/map/conference';
import dectIcon from '../../assets/icons/map/dect';
import equipmentIcon from '../../assets/icons/map/equipment';
import faxIcon from '../../assets/icons/map/fax';
import gymIcon from '../../assets/icons/map/gym';
import helpMachineIcon from '../../assets/icons/map/helpMachine';
import hypercubeIcon from '../../assets/icons/map/hypercube';
import libraryIcon from '../../assets/icons/map/library';
import massageChairIcon from '../../assets/icons/map/massageChair';
import phoneBoothIcon from '../../assets/icons/map/phoneBooth';
import photoBoothIcon from '../../assets/icons/map/photoBooth';
import photoSpotIcon from '../../assets/icons/map/photoSpot';
import printerIcon from '../../assets/icons/map/printer';
import rj45Icon from '../../assets/icons/map/rj45';
import roomIcon from '../../assets/icons/map/room';
import scannerIcon from '../../assets/icons/map/scanner';
import sensorIcon from '../../assets/icons/map/sensor';
import showerIcon from '../../assets/icons/map/shower';
import shredderIcon from '../../assets/icons/map/shredder';
import sleepCapsuleIcon from '../../assets/icons/map/sleepCapsule';
import smokingIcon from '../../assets/icons/map/smoking';
import stationeryIcon from '../../assets/icons/map/stationery';
import vendingIcon from '../../assets/icons/map/vending';
import wardrobeIcon from '../../assets/icons/map/wardrobe';
import wcIcon from '../../assets/icons/map/wc';
import wifiIcon from '../../assets/icons/map/wifi';
import wifiPlatformIcon from '../../assets/icons/map/wifiPlatform';
import wifiSensorIcon from '../../assets/icons/map/wifiSensor';
import zombieIcon from '../../assets/icons/map/zombie';
import mlIcon from '../../assets/icons/ml';
import npmIcon from '../../assets/icons/npm';
import stackoverflowIcon from '../../assets/icons/stackoverflow';
import trackerIcon from '../../assets/icons/tracker';
import wikiIcon from '../../assets/icons/wiki';
import chatIcon from '../../assets/icons/chat';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var ICONS_BY_LAYER = {
  atushka: {
    icon: atushkaIcon,
    size: {
      m: 20,
      s: 14
    }
  },
  doc: {
    icon: docIcon,
    size: {
      m: 14,
      s: 12
    }
  },
  calendar: {
    icon: calendarIcon,
    size: {
      m: 16,
      s: 14
    }
  },
  goals: {
    icon: goalsIcon
  },
  help: {
    icon: helpIcon,
    size: {
      m: 28,
      s: 21
    }
  },
  issues: {
    icon: trackerIcon,
    size: {
      m: 14,
      s: 12
    }
  },
  ml: {
    icon: mlIcon
  },
  stackoverflow: {
    icon: stackoverflowIcon,
    size: {
      m: 40,
      s: 30
    }
  },
  npm: {
    icon: npmIcon,
    size: {
      m: 14,
      s: 12
    }
  },
  map: {
    icon: roomIcon
  },
  services: {
    icon: abcIcon,
    size: {
      m: 20,
      s: 14
    }
  },
  wiki: {
    icon: wikiIcon,
    size: {
      m: 19,
      s: 16
    }
  },
  groups: {
    icon: BranchesDown,
    size: {
      m: 17,
      s: 12
    }
  },
  chat: {
    icon: chatIcon,
    size: {
      m: 16,
      s: 14
    }
  }
};
var ICONS_BY_TYPE = {
  equipment: {
    icon: equipmentIcon,
    size: {
      m: 18,
      s: 14
    }
  },
  conferences: {
    icon: conferenceIcon,
    size: {
      m: 22,
      s: 16
    }
  },
  rooms: {
    icon: roomIcon
  }
};
var ICONS_BY_SUBTYPE = {
  printer: {
    icon: printerIcon
  },
  scanner: {
    icon: scannerIcon
  },
  copier: {
    icon: printerIcon
  },
  mfp: {
    icon: printerIcon
  },
  dect: {
    icon: dectIcon
  },
  wifi: {
    icon: wifiIcon
  },
  wifi_mount_platform: {
    icon: wifiPlatformIcon
  },
  rj45: {
    icon: rj45Icon
  },
  fax: {
    icon: faxIcon
  },
  shredder: {
    icon: shredderIcon
  },
  stationery_cabinet: {
    icon: stationeryIcon
  },
  hypercube: {
    icon: hypercubeIcon
  },
  sensor: {
    icon: sensorIcon
  },
  zombie: {
    icon: zombieIcon
  },
  wifi_sensor: {
    icon: wifiSensorIcon
  },
  vending_machine: {
    icon: vendingIcon
  },
  help_machine: {
    icon: helpMachineIcon
  },
  atm: {
    icon: atmIcon
  },
  massage_chair: {
    icon: massageChairIcon
  },
  battery_recycling_container: {
    icon: batteryContainerIcon
  },
  sleep_capsule: {
    icon: sleepCapsuleIcon
  },
  photo_booth: {
    icon: photoBoothIcon
  },
  photo_spot: {
    icon: photoSpotIcon
  },
  balcony: {
    icon: balconyIcon
  },
  coffee: {
    icon: coffeeIcon
  },
  gym: {
    icon: gymIcon
  },
  library: {
    icon: libraryIcon
  },
  phone_booth: {
    icon: phoneBoothIcon
  },
  shower: {
    icon: showerIcon
  },
  smoking: {
    icon: smokingIcon
  },
  wardrobe: {
    icon: wardrobeIcon
  },
  wc: {
    icon: wcIcon
  }
};
var DEFAULT_SIZE = {
  s: 24,
  m: 32,
  l: 38
};
export var LayerIcon = /*#__PURE__*/React.memo(function LayerIcon(_ref) {
  var _ref2, _ICONS_BY_SUBTYPE, _data$size$size, _data$size;
  var layer = _ref.layer,
    type = _ref.type,
    subtype = _ref.subtype,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'm' : _ref$size;
  var data = (_ref2 = (_ICONS_BY_SUBTYPE = ICONS_BY_SUBTYPE[subtype]) !== null && _ICONS_BY_SUBTYPE !== void 0 ? _ICONS_BY_SUBTYPE : ICONS_BY_TYPE[type]) !== null && _ref2 !== void 0 ? _ref2 : ICONS_BY_LAYER[layer];
  var iconSize = typeof size === 'number' ? size : (_data$size$size = data === null || data === void 0 || (_data$size = data.size) === null || _data$size === void 0 ? void 0 : _data$size[size]) !== null && _data$size$size !== void 0 ? _data$size$size : DEFAULT_SIZE['m'];
  return data !== null && data !== void 0 && data.icon ? /*#__PURE__*/_jsx(Icon, {
    data: data === null || data === void 0 ? void 0 : data.icon,
    size: iconSize
  }) : /*#__PURE__*/_jsx(_Fragment, {
    children: layer.charAt(0).toUpperCase()
  });
});
// #sourceMappingURL=LayerIcon.js.map